const booleanStrings = ['true', 'false'];

export const castBooleanQsParam = (v: string | (string | null)[] | null) => {
  if (!v || Array.isArray(v) || v === 'false' || !booleanStrings.includes(v)) {
    return false;
  }
  return true;
};
